import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-forest shadow-lg py-2" : "bg-forest py-3"
      }`}
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Mobile Header */}
        <div className="flex md:hidden items-center justify-between">
          <a href="/" className="flex-1" />
          <a href="/" className="flex items-center justify-center" data-testid="logo-mobile">
            <img 
              src="https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/tql0rd5s_6cf00645-7ffc-4b87-89b5-7aecf16c3cb9.jpeg" 
              alt="Plantora Logo" 
              className="h-16 w-auto object-contain"
            />
          </a>
          <div className="flex-1 flex justify-end">
            <button 
              className="p-2 text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Desktop Header */}
        <div className="hidden md:flex items-center justify-between relative">
          <nav className="flex items-center gap-8">
            <Link 
              to="/why-plantora"
              className="text-white/80 hover:text-white font-medium transition-colors"
              data-testid="nav-why-plantora"
            >
              Why Plantora
            </Link>
            <button 
              onClick={() => scrollToSection("features")}
              className="text-white/80 hover:text-white font-medium transition-colors"
              data-testid="nav-features"
            >
              Features
            </button>
          </nav>

          {/* Logo - Centered and Bigger */}
          <a href="/" className="absolute left-1/2 -translate-x-1/2" data-testid="logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/tql0rd5s_6cf00645-7ffc-4b87-89b5-7aecf16c3cb9.jpeg" 
              alt="Plantora Logo" 
              className="h-24 lg:h-28 w-auto object-contain"
            />
          </a>

          <nav className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection("products")}
              className="text-white/80 hover:text-white font-medium transition-colors"
              data-testid="nav-products"
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection("contact")}
              className="text-white/80 hover:text-white font-medium transition-colors"
              data-testid="nav-contact"
            >
              Contact
            </button>
          </nav>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-forest shadow-lg border-t border-white/10">
          <div className="px-6 py-4 space-y-4">
            <Link 
              to="/why-plantora"
              className="block w-full text-left text-white font-medium py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Why Plantora
            </Link>
            <button 
              onClick={() => scrollToSection("features")}
              className="block w-full text-left text-white font-medium py-2"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection("products")}
              className="block w-full text-left text-white font-medium py-2"
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left text-white font-medium py-2"
            >
              Contact
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
